export const TRANSLATION_PROPS = {
    priceCardTabFullPriceTxt: {
        id: 'priceCardTabFullPriceTxt',
        defaultMessage: 'Car price'
    },
    priceCardTabEmiTxt: {
        id: 'priceCardTabEmiTxt',
        defaultMessage: 'Estimated monthly price'
    },
    priceCardTabMonths: {
        id: 'priceCardTabMonths',
        defaultMessage: 'months'
    },
    priceCardTabDownPayment: {
        id: 'priceCardTabDownPayment',
        defaultMessage: 'Down payment'
    },
    emiCalculator: {
        id: 'emiCalculator',
        defaultMessage: 'EMI Calculator'
    }
};

export const PRICE_CARD_TABS = {
    FULL_PRICE: 'full_price',
    EMI: 'emi'
};

export const PAYMENT_FREQUENCY = 'monthly';

export const SHOW_PRICE_CARD_TABS = 'show_price_card_tabs';
